import { Button } from '@iwoca/orion';

import { OngoingPaymentPlan } from '../../Dashboard.types';
import { formatCurrency } from '../../utils/currency';
import { formatDate } from '../../utils/date';

export const RepayEarly = ({
  paymentPlan,
}: {
  paymentPlan: OngoingPaymentPlan;
}) => {
  const account = paymentPlan.account;
  const accountId = account.account_id;

  if (!accountId) return null;

  const nextRepayment =
    account.scheduled_payments?.summary?.simplified_schedule?.next_repayment;
  const equalRepayments =
    account.scheduled_payments?.summary?.simplified_schedule?.equal_repayments;

  const nextRepaymentAmount = nextRepayment?.amount ?? equalRepayments?.amount;
  const nextRepaymentDate =
    nextRepayment?.date ?? equalRepayments?.first_standard_repayment_date;

  const isRepaymentToday = (() => {
    if (!nextRepaymentDate) return false;
    const repaymentDate = new Date(nextRepaymentDate);
    const today = new Date();
    return (
      repaymentDate.getFullYear() === today.getFullYear() &&
      repaymentDate.getMonth() === today.getMonth() &&
      repaymentDate.getDate() === today.getDate()
    );
  })();

  return (
    <>
      {nextRepaymentAmount !== undefined && nextRepaymentDate && (
        <div
          data-testid="repay-early-explanation"
          className="text-m font-reg text-structure-20"
        >
          Your next automatic payment of{' '}
          <span className="font-bold">
            {formatCurrency(nextRepaymentAmount)}
          </span>{' '}
          will be on {formatDate(nextRepaymentDate)}. You can make a payment
          here any time with no extra fees.
        </div>
      )}

      <a
        href={`/pay/repayment/choose-amount/?accountId=${accountId}`}
        className="mt-l inline-block"
      >
        <Button data-testid="repay-early-cta" type="button">
          {isRepaymentToday ? 'Make a payment' : 'Make an early payment'}
        </Button>
      </a>
    </>
  );
};
